// extracted by mini-css-extract-plugin
module.exports = {"thumbnailWrapper":"RealizationThumbnailImage_thumbnailWrapper__3gePD","thumbnailImage":"RealizationThumbnailImage_thumbnailImage__3IQNk"};